import { Container, Button } from "react-bootstrap";
import backdrop from "../../assets/images/page-not-found.png";

function Error500({ errorMessage = "Terjadi kesalahan pada server kami" }) {
  return (
    <section className="cover-background position-relative page-not-found" style={{ background: `url(${backdrop})` }}>
      <div className="overlay-notfound"></div>
      <Container className="center-vertical position-relative" style={{ height: "calc(100vh - 2rem)" }}>
        <div className="d-flex flex-column">
          <div className="mb-3">
            <svg width="72" height="68" viewBox="0 0 72 68" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M64 0.5H8C3.58 0.5 0 4.08 0 8.5V19.42C0 19.98 0.44 20.42 1 20.42H71C71.56 20.42 72 19.98 72 19.42V8.5C72 4.08 68.42 0.5 64 0.5ZM12 14.5C9.8 14.5 8 12.7 8 10.5C8 8.3 9.8 6.5 12 6.5C14.2 6.5 16 8.3 16 10.5C16 12.7 14.2 14.5 12 14.5ZM25 14.5C22.8 14.5 21 12.7 21 10.5C21 8.3 22.8 6.5 25 6.5C27.2 6.5 29 8.3 29 10.5C29 12.7 27.2 14.5 25 14.5Z"
                fill="white"
              />
              <path
                d="M71 25.4199H1C0.44 25.4199 0 25.8599 0 26.4199V59.4999C0 63.9199 3.58 67.4999 8 67.4999H64C68.42 67.4999 72 63.9199 72 59.4999V26.4199C72 25.8599 71.56 25.4199 71 25.4199ZM22 54.5199C22 55.6199 21.1 56.5199 20 56.5199C18.9 56.5199 18 55.6199 18 54.5199V48.8399C18 47.7399 17.1 46.8399 16 46.8399C14.9 46.8399 14 47.7399 14 48.8399V54.5199C14 55.6199 13.1 56.5199 12 56.5199C10.9 56.5199 10 55.6199 10 54.5199V38.4599C10 37.3599 10.9 36.4599 12 36.4599C13.1 36.4599 14 37.3599 14 38.4599V42.8399C14 43.9399 14.9 44.8399 16 44.8399C17.1 44.8399 18 43.9399 18 42.8399V38.4599C18 37.3599 18.9 36.4599 20 36.4599C21.1 36.4599 22 37.3599 22 38.4599V54.5199ZM38.7 50.4799C38.7 53.7799 36 56.4799 32.7 56.4799H31.68C28.38 56.4799 25.68 53.7799 25.68 50.4799V42.4199C25.68 39.1199 28.38 36.4199 31.68 36.4199H32.7C36 36.4199 38.7 39.1199 38.7 42.4199V50.4799ZM55.54 50.4799C55.54 53.7799 52.84 56.4799 49.54 56.4799H48.52C45.22 56.4799 42.52 53.7799 42.52 50.4799V42.4199C42.52 39.1199 45.22 36.4199 48.52 36.4199H49.54C52.84 36.4199 55.54 39.1199 55.54 42.4199V50.4799ZM32.7 40.4199H31.68C30.58 40.4199 29.68 41.3199 29.68 42.4199V50.4799C29.68 51.5799 30.58 52.4799 31.68 52.4799H32.7C33.8 52.4799 34.7 51.5799 34.7 50.4799V42.4199C34.7 41.3199 33.8 40.4199 32.7 40.4199ZM49.54 40.4199H48.52C47.42 40.4199 46.52 41.3199 46.52 42.4199V50.4799C46.52 51.5799 47.42 52.4799 48.52 52.4799H49.54C50.64 52.4799 51.54 51.5799 51.54 50.4799V42.4199C51.54 41.3199 50.64 40.4199 49.54 40.4199Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="title mb-2">Error 500 - Server Error</div>
          <div className="description mb-3">
            {errorMessage}
            <br />
            <br />
            Tim kami sedang bekerja untuk memperbaikinya. Silakan refresh halaman untuk mencoba kembali.
          </div>
          <div className="group">
            <Button className="btn-pink mb-3" variant="primary" type="button" onClick={() => window.location.reload()}>
              Refresh Halaman
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Error500;
